import { Button } from '@slal/ui/buttons';
import { Modal, ModalBody, ModalFooter, ModalProps } from '@slal/ui/modal';
import { Article, Heading, P } from '@slal/ui/typography';
import { useCallback } from 'react';

export const DeclarationModal = ({ isOpen, onClose }: ModalProps) => {
    const closeModal = useCallback(() => {
        onClose();
    }, [onClose]);

    return (
        <Modal isOpen={isOpen} onClose={closeModal} title="Valuable features & guarantees">
            <ModalBody>
                <Article>
                    <P>
                        Some pensions, generally older ones, have valuable benefits and guarantees you could lose on
                        transfer. ReAssure will have discussed these with you if you've spoken to them about taking a
                        retirement option. Alternatively you should check your annual statement or call ReAssure on 0800
                        073 1777 to find out if you have:
                    </P>
                    <Heading level={5}>Guaranteed income</Heading>
                    <P>
                        Some pensions give you a guaranteed income during retirement. This could include guaranteed
                        annuity rates. They're now rare, but you may have one if you're older and worked for a larger
                        employer.
                    </P>
                    <Heading level={5}>Investment guarantees</Heading>
                    <P>
                        Some pensions have investment guarantees. These are unusual and will be explained to you in your
                        annual statement.
                    </P>
                    <Heading level={5}>Enhanced tax-free cash</Heading>
                    <P>
                        Some pensions from before 2006 allow you to take more than the usual 25% of your pension money
                        tax-free.
                    </P>
                    <Heading level={5}>Protected pension age</Heading>
                    <P>
                        Some pensions allow you to retire before the normal retirement age (currently 55, rising to age
                        57 on the 6th of April 2028).
                    </P>
                    <Heading level={5}>Life insurance or dependent benefits</Heading>
                    <P>
                        Other benefits, like life insurance, may be lost when you transfer. You can usually purchase
                        alternative cover, but this can be difficult if you're in ill health. Speak to a financial
                        adviser if you're unsure.
                    </P>
                </Article>
            </ModalBody>
            <ModalFooter>
                <Button variant="solid" color="secondary" onClick={closeModal}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};
